import React from "react";
import styles from "./chat.module.scss";

// Tek avatar primitive.
//  - DM: daire, resim/baş-harf.
//  - Grup: yuvarlak-KARE + renkli + Users ikonu (DM'den net ayrışır).
//  - AI: dönen-gradient yerine sabit mor (liste/header'da).
const Avatar = ({ src, name = "?", initials, color, size = 44, online = false, square = false, icon = null }) => {
  const label = initials || (name || "?").trim().charAt(0).toUpperCase();
  return (
    <span
      className={`${styles.avatar} ${square ? styles.avatarSquare : ""}`}
      style={{ "--avatar-size": `${size}px`, "--avatar-bg": color || "#64748b" }}
    >
      {src ? (
        <img src={src} alt={name} className={styles.avatarImg} />
      ) : icon ? (
        <span className={styles.avatarIcon}>{icon}</span>
      ) : (
        <span className={styles.avatarInitials}>{label}</span>
      )}
      {online && <span className={styles.avatarOnline} aria-hidden="true" />}
    </span>
  );
};

export default Avatar;
